// userService.js
import { get, post, patch } from './common';


export const vonageAccessToken  = (data) => {
    return post('vonage/vonage-access-token', data);
};

export const vonageStartStopRecording  = (data) => {
    return post('vonage/vonage-start-stop-recording', data);
};

export const vonageStreamActions  = (data) => {
    return post('vonage/vonage-stream-actions', data);
};


export const createCall1  = (id) => {
    return post('chat/chat-action/'+id);
};

export const screenshotUpload = (id, data) => {
    return post('calls/upload-screenshot/'+id, data, { "content-type": "multipart/form-data"});
}

export const vonageChangeLayoutClass = (data) => {
    return post('vonage/change-layout/', data);
}

export const sendTranscriptMsg = (id, data) => {
    return post('calls/transcript/'+id, data);
}

